export default function buildAccordionClickFunction(accordionId: string) {
  return () => {
    (document.querySelector(`#${accordionId} .accordion-button`) as HTMLButtonElement)?.click();
  };
}
